import { Component, inject } from '@angular/core';
import { LocalCsvService } from '../../../../../../../services/local-csv/local-csv.service';

@Component({
  selector: 'csv-phone-removed',
  standalone: true,
  imports: [],
  templateUrl: './removed.component.html',
  styleUrl: './removed.component.css'
})
export class RemovedComponent {
constructor(){}

localCSVService = inject(LocalCsvService)

get removedPhoneNumbers(){
  return this.localCSVService.getRemoved
}
}
